"use strict";

import angular from "angular";

angular.module("nucont.accounting.group").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider.state(
        "nucont.accounting.group.demonstrations.accounting.balancesheet",
        {
            url: "/balancete/:date",
            views: {
                "demonstrationAccountingView@nucont.accounting.group.demonstrations.accounting": {
                    component: "accountingBalanceSheetComponent",
                    bindings: { companyData: "groupData" }
                }
            },
            params: {
                demonstration: { value: "balancete", dynamic: false },
                date: { value: null, dynamic: true },
                source: { value: "contabil" },
                stateIndentifier: { value: "dre" }
            },
            bodyClass: "dre-module"
        }
    );
}
